/*
What a signed-out visitor is told they get from a free account, and the page a
sign-up CTA reports. Shared by LoginRequiredDialog, OptimizationCompletedDialog
and PostSolveConversionCard so the three can't drift apart.

Every benefit here must be true of the free Starter plan today. The first
version of these prompts promised "unlimited scenarios" (Starter saves 10), a
"1,000 tasks / month" allowance (no such quota exists), and "driver sheets",
PDF manifests and turn-by-turn directions (the app has none of them, and its
.csv/.xlsx table downloads don't need an account). Plan numbers are left out on
purpose: they live in the backend's plan catalog and change there, and a number
written down here would be the first thing to go stale.
*/

export const ACCOUNT_BENEFITS = [
  "Save your scenarios and come back to them later",
  "Open your saved work from any device",
  "Keep a history of your optimization runs",
];

/**
 * The `page` property for CTA_CLICKED, in the same shape as the marketing CTAs
 * ("home", "industries/field-service"): the current route without its leading
 * slash, e.g. "models/vehicle-routing" or "examples/boston-elderly-bus-service".
 * No query string or hash, so nothing a visitor typed can end up in analytics.
 */
export function ctaPage() {
  try {
    const path = (window.location && window.location.pathname) || "";
    return path.replace(/^\/+/, "") || "home";
  } catch (e) {
    return "unknown";
  }
}
